/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import ScreenContainerSimpleLayoutConnexion from '../layouts/ScreenContainerSimpleLayoutConnexion'
import ROUTES from '../utils/ROUTES'
import Button from '../components/Button'

const ModifyUserProfilCheck = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation<any>().state
  const { updatedBy } = location || {}

  if (location === undefined) {
    history.push(ROUTES.NotFoundPage)
    return <></>
  }

  return (
    <>
      <ScreenContainerSimpleLayoutConnexion>
        <div className="email-modified">
          <div className="email-modified_text-container">
            <div className="content">
              <p className="infos">
                {t('ModifyUserProfilCheck.info')}
                {updatedBy && (
                  <span>
                    {updatedBy.firstname.charAt(0).toUpperCase() +
                      updatedBy.firstname.slice(1)}{' '}
                    {updatedBy.lastname.toUpperCase()}.
                  </span>
                )}
              </p>
              <p> {t('ModifyUserProfilCheck.supplementaryInfoTitle')} </p>
              <Button onClick={() => history.push(ROUTES.Home)}>
                {t('ModifyUserProfilCheck.button')}
              </Button>
            </div>
          </div>
        </div>
      </ScreenContainerSimpleLayoutConnexion>
    </>
  )
}
export default ModifyUserProfilCheck
